import {array, mixed, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';
import {localizedTextRequired, stringOptionalNullable} from '@shared/utils';

export const sortOptionV8nSchema = object().shape({
  id: string().required(),
  name: string().required(),
});

export const v8nSchemaOfGetSortOptionsResponse =
  array().of(sortOptionV8nSchema);

export const geoFilterOptionV8nSchema = object().shape({
  id: string().required(),
  name: string().defined(),
  logo_url: mixed().nullable().optional(),
});

export const v8nSchemaOfGetGeoFilterOptionsResponse = array().of(
  geoFilterOptionV8nSchema,
);

export const adminGeoFilterDetailV8nSchema = object().shape({
  id: string().required(),
  name: localizedTextRequired,
  logo_url: stringOptionalNullable,
});

export const fileUploadResponseV8nSchema = object().shape({
  key: string().required(),
  public_url: string().required(),
});

export const marketplaceItemMappingV8nSchema = object().shape({
  id: string().required(),
  avatar_item_id: string().required(),
  gear_item_id: string().required(),
  image_url: string().required(),
});

export const v8nSchemaOfGetMarketplaceItemMappingsResponse =
  paginationV8nSchema.shape({
    array: array().of(marketplaceItemMappingV8nSchema),
  });
